<template>
  <div class="campaigns-page mt-4">
    <app-page-header title="Campanhas"></app-page-header>

    <div class="container">
      <div class="row">
        <div class="col-12 content-container">
          <ul class="campaigns">
            <li
              v-for="campaign of data"
              :key="campaign.id"
              class="campaigns__item"
              @click="viewCampaign(campaign)"
            >
              <h1>{{ campaign.name }}</h1>
              <p>
                <b-icon size="is-small" icon="calendar"></b-icon>
                {{ campaign.datetime | date('DD/MM/YYYY [às] HH:mm') }}
              </p>
            </li>
          </ul>
          <b-pagination
            @change="onPageChange"
            :total="total"
            :current.sync="page"
            :per-page="perPage"
            :range-before="1"
            :range-after="1"
            aria-next-label="Próxima página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página atual"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignService from '@/services/campaign.service';

export default {
  name: 'campaigns-page',
  data: () => {
    return {
      isLoading: true,
      data: [],
      page: 1,
      perPage: 5,
      total: 0,
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    load() {
      CampaignService.getByNetwork(this.user.network_id, {
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { data, total } = response.data;

          this.total = total;
          this.data = data;
        })
        .finally(() => (this.isLoading = false));
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
    viewCampaign(campaign) {
      this.$router.push({
        name: 'points.campaigns.view',
        params: {
          id: campaign.id,
        },
      });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.campaigns-page {
  .content-container {
    max-width: 800px;
    margin: auto;
  }

  .campaigns {
    margin-bottom: 32px;

    &__item {
      padding: 16px;
      border-bottom: 1px solid var(--color-secondary);
      transition: background 0.2s ease-in-out;
      cursor: pointer;

      &:hover {
        background: rgba(0, 0, 0, 0.02);
      }

      h1 {
        color: var(--color-primary);
        font-size: 1.1em;
        font-family: var(--font-family-secondary);
        font-weight: bold;
        text-transform: uppercase;
      }

      p {
        color: var(--text-color-light);
        font-size: 0.9em;
      }
    }
  }
}
</style>
